export const NAV_LINKS = [
  { href: '/services', label: 'Services' },
  { href: '/mvp', label: 'MVP' },
  { href: '/work', label: 'Work' },
  { href: '/about', label: 'About' },
  { href: '/blog', label: 'Insights' },
] as const
